/* eslint-disable max-len */
import React, {useState} from 'react';
import './styles.css';
import Popup from './Popup';
import axios from 'axios';
import {Toast} from './SweetAlert';
import TokenManager from './TokenManager';
/* eslint "require-jsdoc": [2, {
    "require": {
        "FunctionDeclaration": true,
        "MethodDefinition": false,
        "ClassDeclaration": false
    }
}]*/
/**
* @return {html} Redeem screen.
  @param {Object} props
  */
function RedeemCard(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [slider, setSlider] = useState(0);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const slide = (e) => {
    setSlider(e.target.value);
    const memberId = TokenManager.getId();
    if (e.target.value >= 670) {
      e.target.value = 0;
      axios.get(`https://blooming-springs-86289.herokuapp.com/api/member/points/${memberId}`)
          .then((response) => {
          // console.log(response);
            let currentPoints = response.data[0].points;
            if (currentPoints >= props.required_points) {
              currentPoints = (currentPoints - props.required_points);
              axios.put(`https://blooming-springs-86289.herokuapp.com/api/member/points/${memberId}`, {
                promoId: props.promoId,
                points: currentPoints,
                memberId: memberId,

              })
                  .then((response) => {
                    Toast.fire({
                      icon: 'success',
                      title: 'Success!',
                      text: 'Voucher successfully added! Head to Profile to check it out!',
                    });
                    setIsOpen(false);
                  });
            } else {
              Toast.fire({
                icon: 'error',
                title: 'Error!',
                text: 'Sorry, you have insufficient points to claim this voucher',
              });
              setIsOpen(false);
            }
          });
    }
  };

  return (
    <div className="container2">
      <div className="vouchercard">
        <div className="main">
          <div id="coupon-amount">${props.amount}</div>
          <div className="vertical"></div>
          <div className="content">
            <span>${props.amount} OFF your next purchase</span>
            <div className="points">
              <h2>{props.required_points} points</h2>
            </div>
            <div className='redeem-button'>
              <input className='clickme'
                type="button"
                value="Redeem"
                onClick={togglePopup}
              />
              <div className='popup'>
                {isOpen && <Popup
                  content={<>
                    <b>Are you sure you want to claim the
                      ${props.amount} voucher
                      for {props.required_points} points?</b>
                    <p>Slide to Confirm</p>
                    <div className="confirmation-slider">
                      <div id="status">
                        <input id="confirm" type="range"
                          min="0" max="710" onChange={(e) => slide(e)}
                          value={slider} />
                      </div>
                    </div>
                  </>}
                  handleClose={togglePopup}
                />}
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>


  );
}

export default RedeemCard;
